import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Container fluid className="footer">
      <Row className="align-items-center text-center">
        {/* Left */}
        <Col md="4" className="footer-copywright">
          <span>Dedicated to creating impactful solutions!</span>
        </Col>

        {/* Center */}
        <Col md="4" className="footer-copywright">
          <span>© {year} All Rights Reserved</span>
        </Col>

        {/* Right */}
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            {/* Email */}
            <li className="social-icons">
              <a
                href="mailto:dhirajdhiman15@gmail.com" // 🔁 replace with your real email
                style={{ color: "white" }}
                aria-label="email"
              >
                <MdEmail />
              </a>
            </li>

            {/* GitHub */}
            <li className="social-icons">
              <a
                href="https://github.com/19sajib"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="github"
              >
                <AiFillGithub />
              </a>
            </li>

            {/* LinkedIn */}
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/19sajib/"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="linkedin"
              >
                <FaLinkedinIn />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
};

export default Footer;
